export default __webpack_public_path__ + "static/media/satisfaction.9b368efa.png";